module.exports = __webpack_public_path__ + "static/media/barras.b1db6d76.png";